import React from "react";
import type { SspPartyResponse } from "../../../../../api/frameworksApi";
import {
  FormDatePicker,
  FormField,
  FormInput,
  FormSelect,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

export interface AddLeveragedAuthorizationDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddLevAuth: () => void;
  addingLevAuth: boolean;
  levAuthForm: {
    title: string;
    partyUuid: string;
    dateAuthorized: string;
  };
  setLevAuthForm: React.Dispatch<
    React.SetStateAction<{
      title: string;
      partyUuid: string;
      dateAuthorized: string;
    }>
  >;
  parties: SspPartyResponse[];
}

export function AddLeveragedAuthorizationDialog({
  open,
  onClose,
  handleAddLevAuth,
  addingLevAuth,
  levAuthForm,
  setLevAuthForm,
  parties,
}: AddLeveragedAuthorizationDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Leveraged Authorization"
      description="Reference an authorization from another system that this SSP inherits controls from"
      size="md"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddLevAuth}
          submitLabel={addingLevAuth ? "Saving" : "Save"}
          submitDisabled={!levAuthForm.title || addingLevAuth}
        />
      }
    >
      <FormField label="Title" required>
        <FormInput
          placeholder="e.g. AWS GovCloud FedRAMP Authorization"
          value={levAuthForm.title}
          onChange={(v) => setLevAuthForm((f) => ({ ...f, title: v }))}
        />
      </FormField>
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Authorizing Party">
          <FormSelect
            options={[
              { label: "— None —", value: "" },
              ...parties.map((p) => ({
                label: `${p.name} (${p.partyType})`,
                value: p.partyUuid,
              })),
            ]}
            placeholder="Select a party"
            value={levAuthForm.partyUuid}
            onChange={(v) => setLevAuthForm((f) => ({ ...f, partyUuid: v }))}
          />
        </FormField>
        <FormField label="Date Authorized">
          <FormDatePicker
            value={levAuthForm.dateAuthorized}
            onChange={(v) =>
              setLevAuthForm((f) => ({ ...f, dateAuthorized: v }))
            }
          />
        </FormField>
      </div>
    </Modal>
  );
}
